export default __webpack_public_path__ + "static/BUS_1-4fb64cd3f188e82c424b29ca9f62374d.jpg";